<template>
  <ag-modal-container
    :title="$t('tokens.title.viewDemands')"
    width="900px"
    @close="back"
  >
    <tokens-demand-view v-if="value" :value="value" />
    <div
      v-if="value && value.status === 'inProgress'"
      class="text-center mt-2"
    >
      <v-btn
        :disabled="loading"
        color="accent"
        class="mx-2"
        replace
        :to="{ path: 'add', query: { demandId: value.id } }"
        v-text="$t('company.demands.addTokenButton')"
      />
      <v-btn
        :disabled="loading"
        :loading="loading"
        color="accent"
        class="mx-2"
        @click="changeStatusToDone"
        v-text="$t('company.demands.changeToDoneButton')"
      />
    </div>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import TokensDemandView from 'src/modules/token/components/TokensDemandView'

export default {
  name: 'CompanyDemandModalContainer',
  components: {
    AgModalContainer,
    TokensDemandView,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    demandId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    value: null,
    loading: false,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.company.getTokensDemand(this.companyId, this.demandId)
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async changeStatusToDone () {
      this.loading = true
      try {
        await Repositories.company.patchTokensDemand(this.companyId, {
          id: this.demandId,
          status: 'done',
        })
        this.value.status = 'done'
        this.showSuccessNotification(this.$t('company.demands.changeToDoneSuccess'))
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
